<div class="lvi-content">
    <div class="avatar">
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="onClick()">
                <span>{{ data.libelle }}</span>
            </a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.parametres.personnalisation.boiteLien.url'"></strong>
                <span>{{ data.url }}</span>
            </li>
            <li>
                <strong [translate]="'admin.parametres.personnalisation.boiteLien.ordre'"></strong>
                <span>{{ data.ordre }}</span>
            </li>
            <li *ngIf="data.remarque != null && data.remarque != ''">
                <strong [translate]="'admin.parametres.personnalisation.boiteLien.remarque'"></strong>
                <mat-icon [nioTooltip]="data.remarque">error_outline</mat-icon>
            </li>
            <li>
                <strong [translate]="'admin.parametres.personnalisation.boiteLien.actif'"></strong>
                <span>{{ (data.actif ? 'global.oui' : 'global.non') | translate }}</span>
            </li>
        </ul>
    </div>
</div>
